import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadPhysicianBatch = (formData) =>
  axios.post(`${BASE_URL}/physicians/batch-upload/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getPhysicianBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/physicians/batch-upload/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getPhysicianBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/physicians/batch-upload/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportPhysicianBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/physicians/batch-upload/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshPhysicianBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/physicians/batch-upload/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );

